module.exports = __webpack_public_path__ + "img/logo.da270af6.png";